import dayjs from 'dayjs';
import { handleUTCConvertTimeZoneTime } from './dayjsFormat';

export const timeZone = (): string => {
  return dayjs.tz.guess();
};

interface IOffsetProps {
  date?: string;
  timezone_?: string;
}
export const timeZoneOffset = ({
  date,
  timezone_,
}: IOffsetProps = {}): number => {
  if (date && timezone_) {
    return dayjs(date).tz(timezone_).utcOffset();
  }
  return dayjs().utcOffset();
};

export const getTargetTimeTimeZone = (date: any, _timezone: string): string => {
  //    这一步将输入的时间视为目标时区的时间，并创建一个 dayjs 对象
  const laTime = dayjs.tz(date, _timezone);

  // 2. 提取所需信息
  //    获取 UTC 偏移量 (±HH:mm)
  const utcOffset = laTime.format('Z'); // 示例输出: -08:00
  //    获取时区缩写 (例如 PST, PDT)
  const timezoneAbbr = laTime.format('z'); // 示例输出: PST

  // 3. 拼接为最终目标格式
  const result = `UTC${utcOffset}/${timezoneAbbr}`;
  return result;
};

export const getTargetTimeTimeZoneFromUtc = (
  date: any,
  _timezone: string,
): string => {
  //    这一步将输入的时间视为目标时区的时间，并创建一个 dayjs 对象
  const laTime = dayjs(date).tz(_timezone);

  // 2. 提取所需信息
  //    获取 UTC 偏移量 (±HH:mm)
  const utcOffset = laTime.format('Z'); // 示例输出: -08:00
  //    获取时区缩写 (例如 PST, PDT)
  const timezoneAbbr = laTime.format('z'); // 示例输出: PST

  // 3. 拼接为最终目标格式
  const result = `UTC${utcOffset}/${timezoneAbbr}`;
  return result;
};

export const timeZoneOffsetBySToM = (timeZoneOffset_: number): number => {
  return timeZoneOffset_ / 60;
};

export const toUtcTimestamp = (time: string): number => {
  const timestamp = dayjs(
    dayjs(time).utc().format('YYYY-MM-DD HH:mm:ss'),
  ).valueOf();
  return timestamp;
};

export const toUtcString = (time?: string): string => {
  if (time == null) {
    return '';
  }
  const str = dayjs(time).utc().format('YYYY-MM-DD HH:mm:ss');
  return str;
};

export const toUtc = (time: string): Date => {
  const date = dayjs(dayjs(time).utc().format('YYYY-MM-DD HH:mm:ss')).toDate();
  return date;
};

export default function formatDate(
  data: number | { valueOf(): number } | unknown,
): string {
  const dataString = dayjs
    .utc(data as number)
    .format('MM-DD HH:mm')
    .toString();
  return dataString;
}

export function formatDateUTCTime(
  data: number | { valueOf(): number } | unknown,
): string {
  const dataString = dayjs
    .utc(data as number)
    .format('YYYY-MM-DD HH:mm:ss')
    .toString();
  return dataString;
}

export function formatDatea(
  data: number | { valueOf(): number } | unknown,
): string {
  const dataString = dayjs(data as number)
    .format('h a')
    .toString();
  return dataString;
}

export function formatDateUTCa(
  data: number | { valueOf(): number } | unknown,
): string {
  const dataString = dayjs
    .utc(data as number)
    .format('h a')
    .toString();
  return dataString;
}

export function formatDateDay(
  data: number | { valueOf(): number } | unknown,
): string {
  const dataString = dayjs(data as number)
    .format('YYYY-MM-DD')
    .toString();
  return dataString;
}

export function formatDateYear(
  data: number | { valueOf(): number } | unknown,
): string {
  const dataString = dayjs(data as number)
    .format('YYYY')
    .toString();
  return dataString;
}

export function formatDateH(
  data: number | { valueOf(): number } | unknown,
): string {
  const dataString = dayjs
    .utc(data as number)
    .format('HH:mm:ss')
    .toString();
  return dataString;
}

/**
 *
 * @param startDate yyyy/MM/dd
 * @param endDate yyyy/MM/dd
 * @returns number
 */
export function numberOfDaysDifference(
  startDate: string,
  endDate: string,
): number {
  try {
    const diff = dayjs(endDate).diff(dayjs(startDate), 'day');
    return diff + 1;
  } catch (error) {
    console.log(error);
  }
  return 0;
}

/**
 *
 * @param startDate yyyy/MM/dd
 * @param endDate yyyy/MM/dd
 * @returns number
 */
export function isNumberOfDaysDifference(
  startDate: string,
  endDate: string,
): boolean {
  try {
    if (
      dayjs(endDate).format('YYYY-MM-DD') ===
      dayjs(startDate).format('YYYY-MM-DD')
    ) {
      return false;
    }
  } catch (error) {
    console.log(error);
  }
  return true;
}

/**
 * Determine whether the time is within this interval
 * @param startTime yyyy-MM-dd HH:mm:ss
 * @param endTime yyyy-MM-dd HH:mm:ss
 * @param contrastTime yyyy-MM-dd HH:mm:ss
 * @returns boolean
 */
export function timeInterval(
  startTime: string,
  endTime: string,
  contrastTime: string,
): boolean {
  const second0 = dayjs(contrastTime).diff(dayjs(startTime), 'second');
  const second1 = dayjs(contrastTime).diff(dayjs(endTime), 'second');
  return second0 >= 0 && second1 <= 0;
}

interface DisableProps {
  date: any;
  targetTime: {
    startTime?: string;
    endTime?: string;
  };
  targetTimezone?: string;
  offset?: number;
}
export const disabledDate = ({
  date,
  targetTime,
  targetTimezone,
  offset,
}: DisableProps) => {
  let resultStart = false;
  let resultEnd = false;
  const offset_ =
    offset ??
    (targetTimezone
      ? timeZoneOffset({
          date: targetTime?.startTime,
          timezone_: targetTimezone,
        }) * 60
      : null) ??
    timeZoneOffset() * 60;
  if (targetTime?.startTime) {
    const patientStartTime = handleUTCConvertTimeZoneTime(
      offset_,
      targetTime?.startTime,
    );
    console.log('patientStartTime.startOf', patientStartTime.startOf('day'));
    resultStart = date && date < patientStartTime.startOf('day');
  }

  if (targetTime?.endTime) {
    const patientEndTime = handleUTCConvertTimeZoneTime(
      offset_,
      targetTime?.endTime,
    );
    resultEnd = date && date > patientEndTime.endOf('day');
  }
  return resultStart || resultEnd;
};

function disabledDateTimeHours({ date, targetTime, offset }: DisableProps) {
  const list: number[] = [];
  if (targetTime.startTime) {
    const patientTime = handleUTCConvertTimeZoneTime(
      offset ?? timeZoneOffset() * 60,
      targetTime.startTime,
    );
    if (patientTime && date != null && patientTime.isSame(date, 'day')) {
      const hours = patientTime.hour();
      for (let index = 0; index < hours; index += 1) {
        list.push(index);
      }
    }
  }
  if (targetTime.endTime) {
    const patientTime = handleUTCConvertTimeZoneTime(
      offset ?? timeZoneOffset() * 60,
      targetTime.endTime,
    );
    if (patientTime && date != null && patientTime.isSame(date, 'day')) {
      const hours = patientTime.hour();
      for (let index = hours + 1; index < 24; index += 1) {
        list.push(index);
      }
    }
  }
  return list;
}

function disabledDateTimeMinutes({ date, targetTime, offset }: DisableProps) {
  const list: number[] = [];
  if (targetTime?.startTime) {
    const utcTime = dayjs
      .utc(targetTime?.startTime)
      .format('YYYY-MM-DD HH:mm:ss');
    const patientTime = handleUTCConvertTimeZoneTime(
      offset ?? timeZoneOffset() * 60,
      utcTime,
    );
    if (
      date != null &&
      patientTime.isSame(date, 'day') &&
      patientTime.isSame(date, 'hour')
    ) {
      const minutes = patientTime.minute();
      for (let index = 0; index < minutes; index += 1) {
        list.push(index);
      }
    }
  }
  if (targetTime?.endTime) {
    const utcTime = dayjs
      .utc(targetTime?.endTime)
      .format('YYYY-MM-DD HH:mm:ss');
    const patientTime = handleUTCConvertTimeZoneTime(
      offset ?? timeZoneOffset() * 60,
      utcTime,
    );
    if (
      date != null &&
      patientTime.isSame(date, 'day') &&
      patientTime.isSame(date, 'hour')
    ) {
      const minutes = patientTime.minute();
      for (let index = minutes + 1; index < 60; index += 1) {
        list.push(index);
      }
    }
  }
  return list;
}

function disabledDateTimeSeconds({ date, targetTime, offset }: DisableProps) {
  const list: number[] = [];
  if (targetTime?.startTime) {
    const utcTime = dayjs
      .utc(targetTime?.startTime)
      .format('YYYY-MM-DD HH:mm:ss');
    const patientTime = handleUTCConvertTimeZoneTime(
      offset ?? timeZoneOffset() * 60,
      utcTime,
    );
    if (
      date != null &&
      patientTime.isSame(date, 'day') &&
      patientTime.isSame(date, 'hour') &&
      patientTime.isSame(date, 'minute')
    ) {
      const seconds = patientTime.second();
      for (let index = 0; index < seconds; index += 1) {
        list.push(index);
      }
    }
  }
  if (targetTime?.endTime) {
    const utcTime = dayjs
      .utc(targetTime?.endTime)
      .format('YYYY-MM-DD HH:mm:ss');
    const patientTime = handleUTCConvertTimeZoneTime(
      offset ?? timeZoneOffset() * 60,
      utcTime,
    );
    if (
      date != null &&
      patientTime.isSame(date, 'day') &&
      patientTime.isSame(date, 'hour') &&
      patientTime.isSame(date, 'minute')
    ) {
      const seconds = patientTime.second();
      for (let index = seconds + 1; index < 60; index += 1) {
        list.push(index);
      }
    }
  }
  return list;
}

export const disabledDateTime = ({
  date,
  targetTime,
  offset,
}: DisableProps) => {
  return {
    disabledHours: () =>
      disabledDateTimeHours({
        date,
        offset,
        targetTime,
      }),
    disabledMinutes: () =>
      disabledDateTimeMinutes({
        date,
        offset,
        targetTime,
      }),
    disabledSeconds: () =>
      disabledDateTimeSeconds({
        date,
        offset,
        targetTime,
      }),
  };
};

export const range = (start: number, end: number) => {
  const result = [];
  for (let i = start; i < end; i += 1) {
    result.push(i);
  }
  return result;
};
